import { styled, Box } from "@mui/material";

export const AppWrapper = styled(Box)({
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    userSelect: "none",
});

